export function canonicalizeExtraLabel(value) {
  const label = String(value || '').trim();
  if (!label) return '';
  return label
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
}

export function isLegacySitioLabel(value) {
  const raw = String(value || '').trim();
  if (!raw) return false;

  const plain = raw.toLowerCase();
  if (plain === 'sitio' || plain === 's?tio') {
    return true;
  }

  const canonical = canonicalizeExtraLabel(raw);
  return canonical === 'sitio' || canonical === 'satio' || canonical === 'stio';
}

export function normalizeExtraLabel(value, fallback = '') {
  const label = String(value || '').trim();
  if (!label) return fallback;
  return isLegacySitioLabel(label) ? 'Adicionais' : label;
}
